import { clientFor } from '@yc/api-client'

const api = clientFor('/nos/api')

/** 工作台 KPI：与后端 internal/home/service.go 的 Stats 的 JSON 字段一一对应 */
export interface HomeStats {
  /** 网点档案总数 */
  total_sites: number
  /** 启用中的网点数（能参与仿真取数的那些） */
  active_sites: number
  /** 路径档案总数 */
  total_lanes: number
  /** 启用中的路径数（仿真里的「现网」） */
  active_lanes: number
  /** 仿真任务总数 */
  total_simulations: number
  /** 待运行 */
  draft: number
  /** 运行中 */
  running: number
  /** 已跑完 */
  done: number
  /** 跑挂的（result 里带 error） */
  failed: number
}

export const getHomeStats = (): Promise<HomeStats> => api.get<HomeStats>('/home/stats')
